<style lang="less" scoped>
@import "../../../vars.less";

.block {
  padding: @space-normal;
  font-size: 14px;
  line-height: 1.8;
  margin-bottom: @space-small;
  background-color: #fff;
  color: @text-color;
}
.main-item {
  margin: 0;
}
.main-item-label {
  display: inline-block;
  color: @text-color-secondary;
  margin-right: @space-normal;
}
.main-item-label:after {
  content: ':'
}
.secondary {
  color: @text-color-secondary;
}
.comment-line {
  margin: 0;
}
.block-title {
  display: flex;
  padding-bottom: @space-medium;
}
.block-title-left {
  flex: auto;
}
.block-title-right {
  flex: none
}
.step {
  h3 {
    margin: 0;
    font-weight: normal;
    line-height: normal;
    font-size: 14px
  }
  p {
    margin: 0;
    color: @text-color;
    font-size: 12px;
  }
  .operation {
    color: @text-color-secondary;
  }
  line-height: 1.6;
}
</style>

<template>
  <page-container class="urgent-order-detail" :title="$t('订单加急详情')" :loading="loading">
    <div class="block">
      <p class="main-item">
        <span class="main-item-label">{{ $t('销售订单号') }}</span>
        <span class="main-item-value">{{ order.GreenChannelUrgentOrderInfo.order_number }}</span>
      </p>
      <p class="main-item">
        <span class="main-item-label">{{ $t('项目名称') }}</span>
        <span class="main-item-value">{{ order.GreenChannelUrgentOrderInfo.ProjectName }}</span>
      </p>
      <p class="main-item">
        <span class="main-item-label">{{ $t('要求货物备妥时间') }}</span>
        <span class="main-item-value">{{
          order.GreenChannelUrgentOrderInfo
            .ReqestSiemensDeliveryDateLastest
            ? order.GreenChannelUrgentOrderInfo
              .ReqestSiemensDeliveryDateLastest
              .split('T')[0]
            : ''
        }}</span>
      </p>
      <p class="main-item">
        <span class="main-item-label">{{ $t('加急原因') }}</span>
        <span class="main-item-value">{{ order.GreenChannelUrgentOrderInfo.ReasonCategoryTypeName }}</span>
      </p>
      <p class="main-item">
        <span class="main-item-label">{{ $t('备注') }}</span>
        <span class="main-item-value">{{ order.GreenChannelUrgentOrderInfo.DatailResaon }}</span>
      </p>
    </div>
    <div class="block">
      <material-list :items="order.Materials" />
    </div>
    <div class="block">
      <div class="block-title van-hairline--bottom">
        <span class="block-title-left">{{ $t('审批记录') }}</span>
        <span class="block-title-right secondary" @click="toggle">
          {{ $t('查看详情') }}
          <van-icon :name="collapsed ? 'arrow-down' : 'arrow-up' " />
        </span>
      </div>
      <van-steps v-show="!collapsed"
        direction="vertical"
        :active="0"
        active-color="#009999"
        active-icon="underway">
        <van-step v-for="item of order.ApprovalHistory" :key="item.Num" class="step">
          <h3>{{ $t('处理步骤') }}: {{ item.NodeDisplayName }}</h3>
          <p>{{$t('审批人')}}: {{ item.Reviewer }}</p>
          <p>{{$t('处理人')}}: {{ item.Executiver }}</p>
          <p>{{$t('审批意见')}}: {{ item.Comments }}</p>
          <p class="operation secondary">{{$t('操作')}}: {{ item.Actions }} {{ item.FinishAt }}</p>
        </van-step>
      </van-steps>

    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../../components/PageContainer'
import { Icon, Steps, Step } from 'vant'
import MaterialList from './MaterialList'

export default {
  name: 'urgent-order-detail',
  components: {
    PageContainer,
    MaterialList,
    'van-icon': Icon,
    'van-steps': Steps,
    'van-step': Step
  },
  data () {
    return {
      collapsed: true,
      order: {
        ApprovalHistory: [],
        GreenChannelUrgentOrderInfo: {},
        Materials: []
      },
      loading: false
    }
  },
  methods: {
    toggle () {
      this.collapsed = !this.collapsed
    },
    getDetail () {
      this.$apis.care.getUrgentOrder(
        this.$route.query.FlowInstanceId,
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          this.order = res
          this.order.ApprovalHistory.reverse()
        }
      })
    }
  },
  mounted () {
    this.getDetail()
  }
}
</script>
